/* eslint-disable @typescript-eslint/no-unused-vars */
import 'bootstrap/dist/css/bootstrap.css';
import 'SharedAssets/Styles/General/all-imported.scss';

import { Spinner, SpinnerEventHandlerArgs, ReportWithNoData } from 'Components';
import React from 'react';
import * as ReactDOM from 'react-dom';
import {
  MultiGroupReport,
  SingleShotReport,
  CombineTestReport,
  CompareReport,
  DrShotAnalysisReport,
} from 'Reports';
import { Injector, EventEmitter } from 'Core';
import { IReportDataService } from 'Services';
import { ReportKind, GetReportKind } from 'Data';

import jquery from 'jquery';
import {
  convertNormalizationToStandardUnits,
  getReportInitialUrlParams,
  getReportStoreByKind,
} from 'utils';
import { NormalizationSettingsType } from 'Components/NormalizationSettings/configs';

Object.assign(global, {
  $: jquery,
  jQuery: jquery,
});

const REPORT_KIND_TO_COMPONENT = {
  [ReportKind.drShotAnalysis]: DrShotAnalysisReport,
  [ReportKind.multiGroupReport]: MultiGroupReport,
  [ReportKind.puttingMultiGroupReport]: MultiGroupReport,
  [ReportKind.singleGroupReport]: MultiGroupReport,
  [ReportKind.puttingSingleGroupReport]: MultiGroupReport,
  [ReportKind.singleShotReport]: SingleShotReport,
  [ReportKind.puttingSingleShotReport]: SingleShotReport,
  [ReportKind.compareReport]: CompareReport,
  [ReportKind.puttingCompareReport]: CompareReport,
  [ReportKind.combineTestReport]: CombineTestReport,
  [ReportKind.testCenterReport]: CombineTestReport,
};

// eslint-disable-next-line @typescript-eslint/no-var-requires
const bootstrap = require('bootstrap');

export abstract class Start {
  static main({
    forceRefetchReport = false,
    preferredNormalizationSettings,
  }: {
    forceRefetchReport?: boolean;
    preferredNormalizationSettings?: NormalizationSettingsType;
  } = {}) {
    const reportDataService = Injector.resolve<IReportDataService>('IReportDataService');
    let reportElement = null;
    const spinnerEventHandler = new EventEmitter<object, SpinnerEventHandlerArgs>();

    // //render spinner separately than report
    ReactDOM.render(
      <Spinner spinnerEventHandler={spinnerEventHandler} />,
      document.getElementById('spinner-root')
    );

    //render report once data is loaded, otherwise nothing to render
    const { reportId, normalization: normalizationSettingsFromUrl } = getReportInitialUrlParams();
    const normalizationSettingsWithStandardUnits = convertNormalizationToStandardUnits(
      preferredNormalizationSettings ?? normalizationSettingsFromUrl
    );
    reportDataService
      .getReportData(reportId, normalizationSettingsWithStandardUnits, forceRefetchReport)
      .done(
        ([reportData]) => {
          const reportKind = GetReportKind(reportData.kind as string);
          const reportStore = getReportStoreByKind(reportKind);
          const ReportComponent = REPORT_KIND_TO_COMPONENT[reportKind];
          reportElement = (
            <ReportComponent
              store={reportStore}
              spinnerEventHandler={spinnerEventHandler}
              updateReportData={(newNormalizationSettings: NormalizationSettingsType) =>
                this.main({
                  forceRefetchReport: true,
                  preferredNormalizationSettings: newNormalizationSettings,
                })
              }
            />
          );
          ReactDOM.render(reportElement, document.getElementById('report-root'));
        },
        () => {
          spinnerEventHandler.emit(this, { hideSpinner: true });
          ReactDOM.render(<ReportWithNoData />, document.getElementById('report-root'));
        }
      );
  }
}
